<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
#main
	width:100%
	height:100vh
	background:#005474
	min-height:840px;
	.chat
		width:1108px
		height:750px
		margin:0 auto
		padding-top:90px
		.box
			height:685px
			background:#fff
			display:flex
			box-shadow:0px 0px 40px rgba(4,40,54,1);
			border-radius:18px;
			.box-l
				width:817px
				border-right:1px solid #eeeeee
				height:100%
				.l-mes
					width:100%
					height:35px
					line-height:35px
					font-size:12px
					background:rgba(0,84,116,0.15);
					padding-left:20px
				.l-chat
					height:490px
					width:100%
					border-bottom: 1px solid #eeeeee
					overflow-y:auto
					padding-top:10px
					.list
						padding:0px 20px 15px 20px
						.listTime
							text-align:center
							color:#999999
							font-size:12px
							padding:5px 0
						.listwait
							display:flex
							justify-content:center
							.wait
								background:#e9ebf0
								border-radius:4px
								padding:1px 20px
								font-size:12px
								color:#999999
						.listlook
							display:flex
							justify-content:center
							cursor:pointer
							color:#1890ff
						.nohistory
							display:flex
							justify-content:center
						.listassess
							display:flex
							justify-content:center
							.assess
								height:150px
								width:360px
								background:#fff
								box-shadow: 0 0 10px rgba(153,153,153,0.56)
								.pjlist
									display:flex
									justify-content:space-around
									align-items:center
									text-align:center
									height:110px
						.el-divider__text
							color:#cccccc
							font-size:12px !important
						.listout
							display:flex
							color:#fff
							.imgss
								width:46px
								height:46px
								border-radius:50%
							.listbox
								padding:0 10px
								.listname
									font-size:12px
									color:#999
								.listmsg
									background:#005474
									margin-right:14px
									padding:7px 15px
									border-radius:10px
									position: relative
									&:after
										left:-5px
										background: #005474
										content: ''
										width: 10px
										height: 10px
										display: inline-block
										position: absolute
										top: 10px
										-webkit-transform: rotate(45deg)
										transform: rotate(45deg)
									.messageimg
										max-width:280px
										max-height:280px
										display:block
										cursor:pointer
								.listpl
									background:#eff1f6
									display:flex
									flex-direction:column
									align-items:center
									justify-content:center
									width:150px
									height:90px
									border-radius:10px
									color:#000
									position: relative
									&:after
										left: -5px
										background: #eff1f6
										content: ''
										width: 10px
										height: 10px
										display: inline-block
										position: absolute
										top: 10px
										-webkit-transform: rotate(45deg)
										transform: rotate(45deg)
									.plimg
										width:40px
										height:40px
								.listType
									background: #eff1f6
									margin-right: 14px
									padding:10px 15px
									border-radius:10px
									position: relative
									width:280px
									height:90px
									display:flex
									justify-content:space-between
									align-items:center
									color:#000
									&:after
										left: -5px
										background: #eff1f6
										content: ''
										width: 10px
										height: 10px
										display: inline-block
										position: absolute
										top: 10px
										-webkit-transform: rotate(45deg)
										transform: rotate(45deg)
									.otherfilename, .downotherfile
										color:#000
										display:inline-block
										max-width:202px
									.imgicon
										width:50px
										height:50px
										margin-right:8px
									.paybtn
										width:70px
										height:31px
										line-height:31px
										background:#1890FF
										color:#fff
										font-size:14px
										text-align:center
										border-radius:16px
										cursor:pointer
						.listin
							display:flex
							flex-direction:row-reverse
							color:#000
							.imgss
								width:46px
								height:46px
								border-radius:50%
							.listbox
								padding:0 10px
								.listname
									font-size:12px
									color:#999
									display:flex
									justify-content:flex-end
								.listmsg
									background:#eff1f6
									margin-left:14px
									padding:7px 15px
									border-radius:10px
									position: relative
									&:after
										right:-5px
										background: #eff1f6
										content: ''
										width: 10px
										height: 10px
										display: inline-block
										position: absolute
										top: 10px
										-webkit-transform: rotate(45deg)
										transform: rotate(45deg)
									.messageimg
										max-width:280px
										max-height:280px
										display:block
										cursor:pointer
								.listpl
									background:#eff1f6
									display:flex
									flex-direction:column
									align-items:center
									justify-content:center
									width:150px
									height:90px
									border-radius:10px
									position: relative
									&:after
										right: -5px
										background: #eff1f6
										content: ''
										width: 10px
										height: 10px
										display: inline-block
										position: absolute
										top: 10px
										-webkit-transform: rotate(45deg)
										transform: rotate(45deg)
									.plimg
										width:40px
										height:40px
								.listType
									background: #eff1f6
									margin-left: 14px
									padding:10px 15px
									border-radius:10px
									position: relative
									width:280px
									height:90px
									display:flex
									justify-content:space-between
									align-items:center
									&:after
										right: -5px
										background: #eff1f6
										content: ''
										width: 10px
										height: 10px
										display: inline-block
										position: absolute
										top: 10px
										-webkit-transform: rotate(45deg)
										transform: rotate(45deg)
									.otherfilename, .downotherfile
										color:#000
										display:inline-block
										max-width:202px
									.imgicon
										width:50px
										height:50px
										margin-right:8px
									.paybtn
										width:70px
										height:31px
										line-height:31px
										background:#1890FF
										color:#fff
										font-size:14px
										text-align:center
										border-radius:16px
										cursor:pointer
				.l-input
					padding-left:15px
					width:100%
					height:125px
					position:relative
					.input
						width:99%
						height: 92px
						padding: 5px 10px
						white-space: pre-wrap
						word-break: break-word
						word-wrap: break-word
						resize: none
						outline: none
						border: 0
					.btn
						position:absolute
						bottom:10px
						right:12px
				.l-icon
					padding-left:20px
					height:35px
					line-height:35px
					width:100%
					border-bottom: 1px solid #eeeeee
					display:flex
					.addemojiicon
						position:relative
						i
							margin-right:20px
							font-size:20px
			.box-r
				width:291px
				height:100%
				padding:10px
				.r-top
					text-align:center;
					margin-top:20px;
					.r-img
						width:90px;
						height:96px;
					.r-title
						font-size:20px;
						margin:15px 0px 20px 0px;
						font-weight:bold;
				.r-course
					font-size:18px;
					font-weight:bold;
					color:rgba(7,19,54,1);
				.r-msg
					margin-top:5px
					display:flex;
					position: relative;
					cursor:pointer;
					.list-img
						width:273px;
						height:119px;
						border-radius: 10px;
					.course-lists
						margin-right: 15px;
						position: absolute;
						left: 95px;
						top:15px;
						.l-title
							height:30px;
							font-size:14px;
							font-weight:500;
							color:rgba(7,19,54,1);
							line-height:15px;
							overflow: hidden;
							display: -webkit-box;
							text-overflow:ellipsis;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
						.l-name
							height:12px;
							font-size:12px;
							font-weight:400;
							color:rgba(7,19,54,0.6);
							line-height:12px;
							margin-top:5px;
						.l-time
							height:12px;
							font-size:10px;
							font-weight:400;
							color:rgba(7,19,54,0.6);
							line-height:12px;
							margin-top:5px;
						.l-btn
							display: flex;
							margin-top:6px;
							.l-type
								// width:85px;
								padding:0 10px;
								height:24px;
								line-height:24px;
								background:rgba(209,173,10,1);
								border-radius:12px;
								color: #ffffff;
								text-align: center;
								margin-right:6px;
		  					.l-type-fldjt
								background-color: #5C607D;
		  					.l-type-no
								background-color: #A3AB5F;
		  					.l-sign
								width:60px;
								height:24px;
								line-height:24px;
								background:rgba(33,177,104,1);
								border-radius:12px;
								color: #ffffff;
								text-align: center;
		  					.l-over
								background:rgba(185,185,185,1);
				.r-more
					color:#005474
					font-size:14px
					height:30px
					line-height:30px
				.r-wechat
					display:flex
					justify-content:space-around
					font-size:12px
					color:#333
					margin-top:20px
					.wechat
						text-align:center
	.dia
		/deep/.el-dialog__title
			font-size:20px
		.pay_ordernum
			color:#333
			font-size:14px
			margin-top:-20px
		.pay-list
			text-align:center
			margin:30px 0
			.pay-list-money
				color:#FF0000
				font-size:20px
			.pay_img_wx
				border:1px solid #00C901
				width:145px
				height:54px
				margin:20px auto
				display:flex
				align-items:center
				justify-content:center
				position: relative
				&:after
					right: 67px
					background: #fff
					content: ''
					width: 10px
					height: 10px
					display: inline-block
					position: absolute
					top: 48px
					-webkit-transform: rotate(45deg)
					transform: rotate(45deg)
					border-bottom: 1px solid #00c901
					border-right: 1px solid #00c901
				.pay_img_wx_text
					color:#515151
					font-size:16px
					margin-left:5px
			.QR_code
				width:152px
				height:152px
				margin 20px auto 0
				border 1px solid #e0e0e0
			.tip_text
				color:#6C6C6C
				font-size:12px
				margin:10px 0
			.warning
				color:#FF1200
				font-size:14px
				margin:10px 0
			.pay-list-btn
				width:100px
				height:34px
				line-height:34px
				background:#939393
				color:#fff
				border-radius:17px
				font-size:14px
				text-align:center
				margin:20px auto
</style>

<template>
  <div id="main">
	<div class="chat">
		<div class="box">
			<div class="box-l">
				<div class="l-mes">注意：咨询过程中，<span style="color:red">请勿关闭</span>当前聊天窗口，关闭后再次进入将重新分配律师，将会影响您的咨询体验哦！</div>
				<div class="l-chat" ref="messagelist">
					<div v-for="(item , index) in mesList" class="list">
					    <div v-if="item.target == 'time'" class="listTime">{{item.content}}</div>
						<div v-if="item.identity == 'support_staff' || item.identity == 'client' || item.identity == 'lawyer' " :class="item.identity == 'client' ? 'listin' : 'listout'">
							<img v-if="item.identity == 'client' || item.identity == 'lawyer'" :src="$avatarHash(item.from)" class="imgss">
							<!-- <img v-if="item.identity == 'support_staff'" :src="$avatarHash(parseInt(list.support_staff_id))" class="imgss"> -->
							<img v-if="item.identity == 'support_staff'" src="/static/img/hxj.png" class="imgss">
							<div class="listbox">
								<div v-if="item.identity== 'client'" class="listname">{{item.name}}</div>
								<div v-if="item.identity== 'lawyer'" class="listname">律师 {{item.name}}</div>
								<div v-if="item.identity== 'support_staff'" class="listname">弘商客服</div>
								<div v-if="!item.filetype"  class="listmsg" v-html="item.content" style="white-space: pre-line; word-break: break-word; word-wrap: break-word"></div>
								<div v-else>
									<!-- 图片 -->
									<div v-if="item.filetype == 'img'" class="listmsg">
	                                    <div v-viewer="{ 'navbar': false, 'toolbar': false, 'rotatable': false, 'scalable': false, 'keyboard': true}">
	                                        <img :title="item.filename" :src="`${imgUrl}/file/preview/${item.filesrc}/img`" class="messageimg">
	                                    </div>
                                    </div>
                                    <div v-else-if="item.filetype == 'com'" class="listpl">
                                    	<div>
                                    		<img v-if="item.filesrc == 10" src="/static/img/chaozan.png" class="plimg">
                                    		<img v-else-if="item.filesrc == 5" src="/static/img/yiban.png" class="plimg">
                                    		<img v-else-if="item.filesrc == 1" src="/static/img/cha.png" class="plimg">
                                    	</div>
                                    	<div>{{item.filename}}</div>
                                    </div>
                                    <div v-else-if="item.filetype == 'pay'" class="listType">
                                    	<div>
                                    		<div style="color:#333;font-size:16px;">法律咨询费支付</div>
                                    		<div style="color:#FF1818;font-size:23px;">¥ {{item.filename.split(';;')[0]}}</div>
                                    	</div>
                                    	<div>
                                    		<div class="paybtn" @click="payother(item)">去支付</div>
                                    	</div>
                                    </div>
                                    <!-- 其他文件 -->
                                    <div v-else class="listType">
                                    	<div>
                                			<div v-if="item.filetype == 'doc' || item.filetype == 'ppt' || item.filetype == 'xls'"><a target="_blank" title="点击预览文件" :href="`${imgUrl}/file/preview/${item.filesrc}`" class="otherfilename single_ellipsis">{{item.filename}}</a></div>
                                			<div v-else>{{item.filename}}</div>
                                			<div style="margin-top:5px"><a target="_blank" title="下载此文件" :href="`${imgUrl}/file/download/${item.filesrc}`" class="downotherfile" style="color:#999;font-size:12px">下载</a></div>
                                		</div>
                                		<div>
                                			<img :src="`/static/img/format/${item.filetype}.jpg`" class="imgicon">
                                		</div>
                                    </div>
								</div>
							</div>
						</div>
						<div v-if="item.target == 'wait'" class="listwait">
							<div class="wait">{{item.msg}}</div>
						</div>
						<div v-if="item.target == 'history'" class="listhistory">
							<el-divider>以上为历史信息</el-divider>
						</div>
						<div v-if="item.target == 'lookhis'" class="listlook" @click="lookHisList">查看历史消息</div>
						<div v-if="item.target == 'nohis'" class="nohistory">没有更早的历史消息了</div>
						<div v-if="item.target == 'assess'  && item.showAssess" class="listassess">
							<div class="assess">
								<div class="pjlist">
									<div @click="checkAssess(10)">
										<img v-show="assess != 10" src="/static/img/chaozan1.png">
										<img v-show="assess == 10" src="/static/img/chaozan.png">
										<div>超赞</div>
									</div>
									<div @click="checkAssess(5)">
										<img v-show="assess != 5" src="/static/img/yiban1.png">
										<img v-show="assess == 5" src="/static/img/yiban.png">
										<div>一般</div>
									</div>
									<div @click="checkAssess(1)">
										<img v-show="assess != 1" src="/static/img/cha1.png">
										<img v-show="assess == 1" src="/static/img/cha.png">
										<div>非常差</div>
									</div>
								</div>
								<div style="display:flex;justify-content:center">
									<el-button size="mini" round type="primary" @click="subAssess(index)">确定</el-button>
								</div>
							</div>
							
						</div>
					</div>
				</div>
				<div v-if="noConsult" class="l-icon">
					<div class="addemojiicon"><i class="iconfont iconbiaoqing"></i></div>
					<!-- 暂时不做文件的发送 smjbgui -->
					<div class="addemojiicon"><i class="iconfont iconicon_photo"></i></div>
					<div class="addemojiicon"><i class="iconfont iconicon_workfile_line"></i></div>
				</div>
				<div v-else class="l-icon">
                    <div @click.self="isshowEmoji = !isshowEmoji" title="发送表情" class="addemojiicon" style="cursor:pointer">
						<i class="iconfont iconbiaoqing" @click.self="isshowEmoji = !isshowEmoji" ></i>
						<z_emoji
	                        ref="emojiwrap"
	                        v-show="isshowEmoji"
	                        @toggleshowEmoji="isshowEmoji = !isshowEmoji"
	                        :currentSay="message"
	                        @changecurrentSay="changeCurrentSayEmoji">
	                    </z_emoji>
                    </div>
                    <!-- 暂时不做文件的发送 smjbgui -->
                    <div class="addemojiicon" title="发送图片" style="cursor:pointer">
                    	<z_fileUpload
                            :params="fileup_param"
                            @fileUpSuccess="fileUpSuccess"
                            @fileUpError="fileUpError"
                            ref="messagefileup">
                            <i class="iconfont iconicon_photo" slot="icon"></i>
                        </z_fileUpload>
                    </div>
					
					<div class="addemojiicon" title="选择文件" style="cursor:pointer">
						<z_fileUpload
                            :params="fileup_param"
                            @fileUpSuccess="fileUpSuccess"
                            @fileUpError="fileUpError"
                            ref="messagefileup">
                            <i class="iconfont iconicon_workfile_line" slot="icon"></i>
                        </z_fileUpload>
					</div>
				</div>
				<div class="l-input">
					<textarea class="input" placeholder="输入您的问题" v-model="message" :maxlength="1000" @keydown.ctrl.enter="lineFeed" @keydown.enter.exact="send" ref="textarea"></textarea>
					<el-button class="btn" size="small" type="primary" round @click="send">发 送</el-button>
				</div>
			</div>
			<div class="box-r">
				<div class="r-top">
					<img src="/static/img/logos.png" class="r-img">
					<div class="r-title">弘商法律云</div>
				</div>
				<div class="r-course">推荐课程</div>
				<div v-for="item in Imglist" class="r-msg">
					<router-link tag="a" target="_blank" :to="{path:'/course/' + item.id}">
						<img :src="item.cover" class="list-img">
						<div class="course-lists">
							<div class="l-title">{{item.title}}</div>
							<div class="l-name">主讲人：{{item.speaker}}</div>
							<!-- <div class="l-time">活动时间：{{item.start_time}}-{{item.end_timehm}}</div> -->
							<div class="l-time">活动时间：{{item.start_time}}</div>
							<div class="l-btn">
								<div class="l-type">{{item.tag_name}}</div>
								<div v-if="item.issign" class="l-sign">报名中</div>
			        			<div v-else class="l-sign l-over">已结束</div>
							</div>
						</div>
					</router-link>
				</div>
				<div class="r-more" style="cursor:pointer" @click="moreCourse">更多课程>></div>
				<div class="r-wechat">
					<div class="wechat">
						<img src="/static/img/wechat.png">
						<div>报名二维码</div>
					</div>
					<div class="wechat">
						<img src="/static/img/qrcode.png">
						<div>平台公众号</div>
					</div>
				</div>
			</div>
		</div>
	</div>
<div class="dia">
	<el-dialog title="法律咨询费支付" :visible.sync="showPay" width="30%">
		<div class="pay_ordernum">订单号{{paylist[1]}}</div>
		<div class="pay-list">
			<div class="pay-list-money">应付金额：  ¥ {{paylist[0]}}</div>
			<div class="pay_img_wx"><img src="/static/icon/0009.png" width="38" height="34"><div class="pay_img_wx_text">微信支付</div></div>
			<div class="QR_code" v-html="QRcodeData"></div>
			<div class="tip_text">扫一扫，完成支付</div>
	        <div class="warning">扫码支付中,请勿跳转页面,避免支付失败</div>
	        <div class="pay-list-btn" @click="closePay">取消订单</div>
        </div>
	</el-dialog> 
	</div>

	<!-- 登录组件 -->
    <outsidelogin v-if="outsideLoginModal" :outsidePhone="outsidePhone"></outsidelogin>

  </div>
</template>

<script>
import outsidelogin from "./outsideLogin";
import z_emoji from '@/components/common/z-emoji';
import z_fileUpload from '@/components/common/z-fileUpload';
import {messageConvert} from '@/common/js/messageConvert';
import moment from 'moment';
export default {
  name: 'zixun',
	data() {
		return {
			imgUrl,
			messageConvert,
			mesList:[],
			Imglist:[],
			message:'',
			isshowEmoji:false,
			timer:'',  //发送消息后的计时器
			timer2:'',
			timer3:'',
			assess:'', //评论等级(1差，5中，10好)
			showAssess:true,  //显示评论
			list:[],
			lawyer_id:'',
			hisnum:0,
			address:'', //地域位置
			visitUrl:'',//来源网址
			beginChat:'', //是否开始进入会话
			lineUpNum:'', //排队数
			again:false,  //是否断开连接，然后在此连接
			isWait:false, //是否在排队
			newTime:false,  //对是否话超出2分钟
			noConsult:false, //当前是否没有客服在线
			paylist:[],
			payconsult_id:'',
			showPay:false,
			QRcodeData:'',
			source:'',
			outsideLoginModal:false,
			token:'',
			outsidePhone:''
		}
	},
	computed: {
		fileup_param() {
            return {
                'about_type': 'consult',
                'about_id': '0',
                'cid': '0'
            }
        },
        consultChat() {
            return this.$store.state.consultChat;
        },
        loginStatus() {
	      	return this.$store.state.loginStatus;
	    },
	    OutsideloginStatus() {
	      return this.$store.state.OutsideloginStatus;
	    }
    },
	created() {

	},
	beforeMount() {
	    this.outsideLoginModal = this.OutsideloginStatus.display;
	  },
	mounted() {
		this.getCourseList();
		this.visitUrl = this.$route.query.visitUrl || '';
		this.source = this.$route.query.source || '';  //外链来源
		this.token = this.$route.query.token || '';  //外链token
		if(this.source != ''){
			this.visitUrl = this.source;
		};
		if(this.loginStatus){
			this.startChats();
		}else{
			if(this.source != ''){
				this.visitUrl = this.source;
				//是否弹咨询登录框
				this.$store.commit('changeOutsideLoginStatus', {display: true,type:0});
				//根据前海token换取手机号
				if(this.token != ''){
					this.getUserphone();
				}
			}else{
				this.$store.commit('clearalldata');
				this.$goto({name: 'home'})
			}
		}
		// console.log('11111',this.visitUrl);
		// this.getuserip();
		// this.startChats();
		this.timer3=setInterval(() =>{
			this.newTime = true;
			// clearInterval(this.timer3);
			// console.log('jishiqi',this.newTime);
		},2*60*1000);
	},
	methods: {
		//获取第三方前海用户手机号
		getUserphone(){
			let url = 'Ucenter/qianhaiUserPhone';
			let data = {
				token:this.token
			};
			this.$ajax('get',url,data,res =>{
				if(res.retcode === 0){
					this.outsidePhone = res.phone
				}
			})
		},
		//支付按钮
		payother(item){
			// console.log('1111',item);
			var list = item.filename.split(';;');
			this.payconsult_id = item.filesrc;
			this.paylist = list;
			this.getqrcodeurl(this.payconsult_id);
			this.showPay = true;
		},
		//关闭支付
		closePay(){
			let url = 'wxm/cancelConsultPay';
			let data = {
				payconsult_id:this.payconsult_id
			};
			this.$ajax('post',url,data,res =>{
				if(res.retcode === 0){
					this.showPay = false;
				}
			})
		},
		//获取二维码的连接url，从而获取二维码。
		getqrcodeurl(id){
        	let url = 'payment/wechat/order';
        	let params ={
        		payconsult_id:id
        	};
        	this.$ajax('post',url,params,res=>{
        		if(res.retcode === 0){
        			// var qrcode_url = res.qrcode_url;
        			this.getqrcode(res.qrcode_url)
        		}
        	}) 
        },
		/* 获取支付二维码 */
        getqrcode(qrcodeurl) {
            this.$http.get(`/qrcode?url=${qrcodeurl}`).then((response) => {
                // 请求成功回调
                let data = response.data;
                this.QRcodeData = data;
                // this.postPay();
            }).catch(err => {
                // 请求失败回调
                console.log('订单信息获取失败！');
            })
        },
		//获取地理位置
		getuserip() {
	      this.$ajax('get', 'getip', data => {
	        if( data.ip_province !== '' && data.ip_city !== '' ){
	        	this.regin = data.ip_province +'/' + data.ip_city;
	        }
	      }, err => {

	      });
	    },
		//获取历史聊天消息 先获取客户咨询记录列表 在获取详情
		lookHisList(){
			let url = 'consultcenter/clientele/consultrecordlist';
			let params = {
				clientele_id:this.$store.state.mineInfo.id,
				is_lawyer:0
			};
			this.$ajax('get' , url , params , res => {
				if (res.retcode === 0) {
					if(this.hisnum < res.data.length){
						if(this.hisnum == 0){
							this.mesList = this.mesList.slice(1);
							let his = {
		                    	target:'history'
		                    };
		                    this.mesList.unshift(his);
		                    let first = {
		                    	target :'lookhis'
		                    };
		                    this.mesList.unshift(first);
						}
						this.getRecordInfo(res.data[this.hisnum].record_id);
		        		this.hisnum = this.hisnum + 1;
					}else{
						this.mesList = this.mesList.slice(1);
						let first = {
	                    	target :'nohis'
	                    };
	                    this.mesList.unshift(first);
					}
		        	
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//获取客户咨询记录详情
		getRecordInfo(id){
			let url = 'consultcenter/clientele/consultrecord';
			let params = {
				record_id:id,
			};
			this.$ajax('get' , url , params , res => {
				if (res.retcode === 0) {
		        	let list = res.data[0].consult_content;
		        	//将数据转换为数组
		        	let messageList = list.replace(/},/g,"},,").split(",,")
		        	for(var i=0;i<messageList.length;i++){
		        		messageList[i]=messageConvert(JSON.parse(messageList[i]))
		        	}
		        	//将数据按照时间排序
		        	messageList = this.timeSort(messageList,'time');
                    let temparr = [];
                    if( messageList.length ){
                        let temptime;
                        messageList.forEach(e => {
                            // 添加聊天时间
                            if( !temptime || (e.time - temptime >= 300) ){
                                let obj = {
                                    content: this.timeconvert2(e.time * 1000),
                                    target: "time",
                                    time: e.time*1000
                                };
                                temparr.push(obj);
                                temptime = e.time;
                            }
                            // 进行信息替换并插入缓存数组
                            temparr.push(messageConvert(e));
                        });
                    }
                    this.mesList = this.mesList.slice(1);
                    this.mesList = temparr.concat(this.mesList);
                    let first = {
                    	target :'lookhis'
                    };
                    this.mesList.unshift(first);
		        	// console.log('lishixiaoxi',this.mesList);
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//将信息发送到后台
		sendMsg(obj,isupload){
			let url='consultcenter/sendchat';
			let users = [];
			users.push(this.list.support_staff_id);
			if(this.lawyer_id){
				users.push(this.lawyer_id);
			};
			let params = {};
			if(isupload){
				params = {
					to:users,
					content:obj.content,
					is_client:1
				}
			}else{
				params = {
					to:users,
					content:this.message,
					is_client:1
				}
			}
			this.$ajax('post' , url , params, res => {
				if (res.retcode === 0) {
		        	// console.log('1111111111',res.data)
		        } else {
		          this.$message.error(res.data.errmsg)
		        }
			})
		},
		//尝试发起咨询 test
		startChats(){
			this.$ajax('get', 'getip', data => {
		        if( data.ip_province !== '' && data.ip_city !== '' ){
		        	this.address = data.ip_province +'/' + data.ip_city;
		        	let url = 'consultcenter/clientele/trytoconnect'
				    let params = {
				    	address:this.address,
				        visitUrl:this.visitUrl
				    }
				    this.$ajax('get' , url, params ,res => {
				        if (res.retcode === 0) {
				        	this.beginChat = res.data.beginChat;
				        	this.lineUpNum = res.data.lineUpNum;
				        	if(res.data.beginChat == 0 && res.data.lineUpNum > 0){
				        		if(!this.mesList.length){
		                			let first = {
							        	target :'lookhis'
							        };
							        this.mesList.unshift(first);		                		
							    }
		                		this.isWait = true;
		                		if(this.mesList[this.mesList.length - 1].target == 'wait' && !this.again){
		                			let list = {
					        			target:'wait',msg:'当前排队人数'+res.data.lineUpNum+'人，请稍等...'
					        		}
					        		this.mesList.splice(this.mesList.length - 1,1,list)
		                		}else{
		                			let list = {
					        			target:'wait',msg:'当前排队人数'+res.data.lineUpNum+'人，请稍等...'
					        		}
					        		this.mesList.push(list);		                		
					        	}
					        	this.again = false;
				        		clearInterval(this.timer2);
			                	this.timer2=setInterval(() =>{
					        		this.startChats();
				        		},30*1000);
				        	}else if(res.data.beginChat == 1 && res.data.lineUpNum == 0){
				        		clearInterval(this.timer2);
				        		this.getChatList();
				        		this.again = false;
				        		this.isWait = false;
				        	}
				        }else if(res.retcode === 1){
				        	this.noConsult = true;
				        	this.$message.error(res.data.errmsg);
				        }else{
				        	this.$message.error(res.data.errmsg);
				        }
				    })
		        }
		    });

		},
		//给对话列表按时间排序
		timeSort(array,key){
			return array.sort(function(a,b){
		     var x = a[key];
		     var y = b[key];
		     return ((x<y)?-1:(x>y)?1:0)
		    })
		},
		//获取对话列表
		getChatList(){
		    let url = 'consultcenter/getchatcontent'
		    let params = {
		        client_id: this.$store.state.mineInfo.id
		    }
		    this.$ajax('get', url, params, res => {
		        if (res.retcode === 0) {
		          	// console.log('对话',res.data);
		          	if(res.data.content_list){
		          		let v = this.timeSort(res.data.content_list,'time');
	                    let temparr = [];
	                    if( v.length ){
	                        let temptime;
	                        v.forEach(e => {
	                            // 添加聊天时间
	                            if( !temptime || (e.time - temptime >= 300) ){
	                                let obj = {
	                                    content: this.timeconvert2(e.time * 1000),
	                                    target: "time",
	                                    time: e.time*1000
	                                };
	                                temparr.push(obj);
	                                temptime = e.time;
	                            }
	                            // 进行信息替换并插入缓存数组
	                            temparr.push(messageConvert(e));
	                        });
	                    };
	                    if(!this.mesList.length){
	                    	let first = {
					        	target :'lookhis'
					        };
					        this.mesList.unshift(first);
	                    }
	                    this.mesList = this.mesList.concat(temparr);
	           //          clearTimeout(this.timer);
	           //      	this.timer=setTimeout(() =>{
		        		// 	// console.log('五分钟了',this.timer)
		        		// 	let option= {
		        		// 		target:'wait',
		        		// 		msg:'本次对话未有人响应，将在一分钟后自动切断哦'
		        		// 	}
		        		// 	this.mesList.push(option);
		        		// 	this.scrollToBottom();
		        		// 	// console.log('关闭计时器',this.timer)
		        		// },5*60*1000);
	                    this.list = res.data;
	                    this.lawyer_id = res.data.lawyer_id;
			          	// this.mesList = res.data.content_list.reverse();
			          	this.scrollToBottom();
			          }else{

			          }
		        }else{
		        	this.$message.error(res.data.errmsg)
		        }
		    });
		},
		// 发消息或来消息滚动到底部
        scrollToBottom() {
            this.$nextTick(() => {
                if( this.$refs.messagelist ){
                    this.$refs.messagelist.scrollTop = this.$refs.messagelist.scrollHeight;
                }
            });
        },
        //ctrl+enter的换行处理
        lineFeed(){
        	this.message = this.message + '\n';
        },
        //发送消息
        send(event){
        	let obj = {
        		identity: 'client',
        		content:this.message,
        		from:this.$store.state.mineInfo.id,
        		name:this.$store.state.mineInfo.name
        	};
        	if(this.noConsult){
        		this.$message.error('暂无客服人员!')
        	}else{
        		// console.log('again',this.again);
        		if(this.again){
        			this.$Message.error('正在重新连接，请稍等...');
        			this.startChats();
        		}else if(this.isWait){
        			this.$Message.error('正在排队中，请稍等...');
        		}else{
        			obj = messageConvert(obj); //转换信息
        			if(this.message == ''){
	        			this.$Message.error('请输入内容后再发送消息！');
	        			event.preventDefault();
        			}else{
        				this.sendMsg();
        				if(this.newTime){
        					var myDate = new Date();
        					var options={
        						content: this.timeconvert2(myDate.getTime()),
        						target: "time",
        					}
        					this.mesList.push(options);
        					this.newTime = false;
        				}
        				this.mesList.push(obj);
        				event.preventDefault();
        				// clearTimeout(this.timer);
        				// this.timer=setTimeout(() =>{
        				// 	let option= {
        				// 		target:'wait',
        				// 		msg:'本次对话未有人响应，将在一分钟后自动切断哦'
        				// 	}
        				// 	this.mesList.push(option);
        				// 	this.scrollToBottom();
        				// },5*60*1000);
        				this.message = '';
        				this.scrollToBottom();
        			}
        		}
        	}	
        },
        //选择表情
        changeCurrentSayEmoji(v) {
            this.message = v;
            this.$refs.textarea.focus();
        },
        //选择评论程度
        checkAssess(i){
        	this.assess = i;
        },
        //确定评价
        subAssess(index){
        	if(this.assess){
	        	let url = 'consultcenter/clientele/feedscore';
	        	let params = {
	        		score_type : this.assess,
	        		user_id : this.list.support_staff_id
	        	};
	        	let mes = '';
	        	if(this.assess == 1){
	        		mes = '非常差'
	        	}else if(this.assess == 5){
	        		mes = '一般'
	        	}else if(this.assess == 10){
	        		mes = '超赞'
	        	};
	        	this.$ajax('get' , url , params , res=>{
	        		if (res.retcode === 0) {
			          	this.mesList[index].showAssess = false;
			          	let objs = {
			          		name : '评价:' + mes,
			          		hash:this.assess,
			          		ext:'com'
			          	};
			          	objs = messageConvert(objs, "encode");
			            this.sendMsg(objs,true);
			            let inmessage = {content: objs.content, identity: 'client', time: moment().format("YYYY-MM-DD HH:mm:ss"),from:this.$store.state.mineInfo.id,name:this.$store.state.mineInfo.name};
			            inmessage = Object.assign(inmessage, objs);
			            this.mesList.push(inmessage);
			        	let obj={
			        		target:'wait',
			        		msg:'感谢您的评价',
			        	}
			        	this.mesList.push(obj);
			        	this.scrollToBottom();
			        	this.assess = '';
			        }else{
			        	this.$message.error(res.data.errmsg)
			        }
	        	})
        	}else{
        		this.$message({
		            type: 'info',
		            message: '请先选择评论！'
		        });
        	}
        	
        },
        //上传成功
        fileUpSuccess(response, file, fileList, params) {
            if( !response.hash ){
                this.$Message.error('服务器错误！上传失败！');
                return false;
            }
            file.name = file.name || "image.png";
            let obj = {
                name: file.name,
                hash: response.hash,
                ext: file.name.substr( file.name.lastIndexOf(".")+1 ).toLowerCase(),
                width: params.imgwidth,
                height: params.imgheight,
                touid: params.about_id
            };
            obj = messageConvert(obj, "encode");
            this.sendMsg(obj,true);
            let inmessage = {content: obj.content, identity: 'client', time: moment().format("YYYY-MM-DD HH:mm:ss"),from:this.$store.state.mineInfo.id,name:this.$store.state.mineInfo.name};
            inmessage = Object.assign(inmessage, obj);
            this.mesList.push(inmessage);
   //          clearTimeout(this.timer);
			// this.timer=setTimeout(() =>{
			// 	let option= {
			// 		target:'wait',
			// 		msg:'本次对话未有人响应，将在一分钟后自动切断哦'
			// 	}
			// 	this.mesList.push(option);
			// 	this.scrollToBottom();
			// },5*60*1000);
            this.scrollToBottom();
        },
        //上传失败
        fileUpError(error, file, fileList, params) {
        	this.$message.error('上传失败，请重新上传！')
            console.log(error, file, fileList, params);
        },
        //获取3个课程列表
        getCourseList(){
		    let url = 'wxm/course/index';
	  		let param = {
	  			page:1,
	  			per_page:2
	  		};
	  		this.$http.get(url, {params:param} ).then(res => {
	  			if(res.data.retcode == $conf.RETCODE_OK){
	  				var datas = res.data.data.data;
	  				var timestamp = Date.parse(new Date());
	        		timestamp = timestamp / 1000;
	        		for(var i = 0 ; i <datas.length ; i++){
			          datas[i].start_time = moment(datas[i].start_time * 1000).format("YYYY-MM-DD HH:mm");
			          if (datas[i].end_time > timestamp){
			            datas[i].issign = true;
			          }else{
			            datas[i].issign = false;
			          };
			          datas[i].end_timehm = moment(datas[i].end_time * 1000).format("HH:mm");
			        };
			        this.Imglist = datas;
	  			}
	  		})
        },
        //更多课程跳转
        moreCourse(){
        	let details = this.$router.resolve({
	          name: "moreCourse",
	          query: {
	            
	          }
	        });
        	window.open(details.href, "_blank")
        },
        //时间转换
        timeconvert2(date) {
            if( moment().isSame(date, 'day') ){
                return moment(date).format('HH:mm:ss');
            }else{
                return moment(date).format('YYYY-MM-DD HH:mm:ss');
            }
        }
  	},
  	watch: {
  		OutsideloginStatus: {
	      deep: true,
	      handler(v, ov) {
	        console.log(v, ov)
	        this.outsideLoginModal = v.display;
	        if(v.type == 1){
	        	this.startChats();
	        }
	      }
	    },
		consultChat : {
			deep: true,
            handler: function(v, ov){
                // console.log('咨询信息:',v);
                let obj = {
                	identity:v.remark.identity,
                	name:v.name,
                	from:v.from,
                	content:v.content,
                	time:v.time
                };
                if(v.type == 'consult_text'){
                	if(this.newTime){
	        			var myDate = new Date();
	        			var options={
	        				content: this.timeconvert2(myDate.getTime()),
	                        target: "time",
	        			}
	        			this.mesList.push(options);
	        			this.newTime = false;
	        		}
                	obj = messageConvert(obj);
                	this.mesList.push(obj);
                	this.scrollToBottom();
           //      	clearTimeout(this.timer);
           //      	this.timer=setTimeout(() =>{
	        		// 	// console.log('五分钟了',this.timer)
	        		// 	let option= {
	        		// 		target:'wait',
	        		// 		msg:'本次对话未有人响应，将在一分钟后自动切断哦'
	        		// 	}
	        		// 	this.mesList.push(option);
	        		// 	this.scrollToBottom();
	        		// 	// console.log('关闭计时器',this.timer)
	        		// },5*60*1000);
	        		// this.timer2=setInterval(() =>{
	        		// 	let options= {
	        		// 		target:'wait',
	        		// 		msg:'未等到您的回复，本次会话已经中断，如您还有问题咨询，可以直接发送信息召唤我哦~',
	        		// 	}
	        		// 	this.mesList.push(options);
	        		// 	this.scrollToBottom();
	        		// 	clearInterval(this.timer2);
	        		// },6*60*1000); 
                }else if(v.type == 'consult_inviteLawyer'){
                	let objs = {
                		target :'wait',
                		msg:'平台正在为您匹配律师'
                	};
                	this.mesList.push(objs);
                	this.scrollToBottom();
                }else if(v.type == 'consult_lawyerJoin'){
                	let objs = {
                		target :'wait',
                		msg: '律师已成功加入当前会话'
                	};
                	this.lawyer_id = v.remark;
                	this.mesList.push(objs);
                	this.scrollToBottom();
                }else if(v.type == "consult_clienteleLose"){
                	let objs = {
                		target :'wait',
                		msg: '未等到您的回复，本次会话已经中断，如您还有问题咨询，可以直接发送信息召唤我哦~'
                	};
                	this.again = true;
                	this.mesList.push(objs);
                	this.scrollToBottom();
                }else if(v.type == "consult_feed"){
                	let obj1 = {
                		target : 'wait',
                		msg: '请您为本次咨询服务评价！'
                	};
                	this.mesList.push(obj1);
                	let objs = {
                		target : 'assess',
                		time : v.time,
                		showAssess : true
                	};
                	// this.showAssess = true;
                	this.mesList.push(objs);
                	this.scrollToBottom();
                }else if (v.type == "consultPayClose") {
			        // let obj2 = {
			        //   target: 'wait',
			        //   msg: '本次咨询已结束!'
			        // };
			        // this.mesList.push(obj2);
			        // this.scrollToBottom();
			    }else if(v.type == "consultPay"){
			    	let objs = {
			          target: 'wait',
			          msg: '正在向您发起咨询付费邀请!'
			        }
			        this.mesList.push(objs);
			        this.scrollToBottom();
			        //取消直接弹框
			  //       var list = [];
			  //       list[0] = v.remark.fee;
			  //       list[1] = v.remark.order_sn
					// this.payconsult_id = v.remark.payconsult_id;
					// this.paylist = list;
					// this.getqrcodeurl(this.payconsult_id);
			  //       this.showPay = true;
			  //       this.scrollToBottom();
			    }else if (v.type == "consult_successConsultPay") {
			    	let obj2 = {
			          target: 'wait',
			          msg: '支付成功!'
			        };
			        this.mesList.push(obj2);
			        this.scrollToBottom();
			        this.showPay = false;
			        this.paylist = [];
			        this.payconsult_id = '';
			    }

            }
		}
  	},
  	filters: {
  		timeconvert(date) {
            if( moment().isSame(date, 'day') ){
                return moment(date).format('HH:mm');
            }else{
                return moment(date).format('YY/MM/DD');
            }
        }
  	},
  	components: {
        z_emoji,
        z_fileUpload,
        outsidelogin
    },
    beforeDestroy(){
    	clearTimeout(this.timer);
    	clearInterval(this.timer2);
    	clearInterval(this.timer3);
    },
}
</script>




// WEBPACK FOOTER //
// src/components/consult/index.vue